import { getDragOriginWhitelist } from "@/api/ai-writer-service";

const state = {
  dragOriginWhitelist: undefined,
};

const getters = {};

const mutations = {
  SET_DRAG_ORIGIN_WHITELIST(state, { dragOriginWhitelist } = {}) {
    state.dragOriginWhitelist = dragOriginWhitelist;
  },
};

const actions = {
  getDragOriginWhitelist({ commit, state }) {
    if (state.dragOriginWhitelist) return state.dragOriginWhitelist;
    const dragOriginWhitelist = getDragOriginWhitelist();
    commit("SET_DRAG_ORIGIN_WHITELIST", { dragOriginWhitelist });
    return dragOriginWhitelist;
  },
};

export default {
  namespaced: true,
  getters,
  state,
  mutations,
  actions,
};
